import { render, staticRenderFns } from "./positionLi.vue?vue&type=template&id=3548e292&scoped=true"
import script from "./positionLi.vue?vue&type=script&lang=js"
export * from "./positionLi.vue?vue&type=script&lang=js"
import style0 from "./positionLi.vue?vue&type=style&index=0&id=3548e292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3548e292",
  null
  
)

export default component.exports